import React from 'react';
import { motion } from 'framer-motion';
import styles from './Recommendations.module.css';

function Section({ title, items, icon, accent }) {
  if (!items || items.length === 0) return null;
  return (
    <div className={styles.section}>
      <h4 className={styles.sectionTitle}>{title}</h4>
      <ul className={styles.list}>
        {items.map((item, i) => (
          <motion.li
            key={item}
            className={styles.listItem}
            initial={{ opacity: 0, x: -12 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: i * 0.06 }}
          >
            <span className={styles.icon} style={{ color: accent, background: `${accent}16` }}>
              {icon}
            </span>
            <span className={styles.itemText}>{item}</span>
          </motion.li>
        ))}
      </ul>
    </div>
  );
}

export default function Recommendations({ strengths, risks, recommendations }) {
  return (
    <motion.div
      className={`${styles.card} aira-card`}
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: 0.2 }}
    >
      <div className={styles.grid}>
        <Section title="Strengths" items={strengths} icon="✓" accent="#1F9D63" />
        <Section title="Top Risks" items={risks} icon="!" accent="#D9433C" />
      </div>
      <Section title="Personalized Recommendations" items={recommendations} icon="→" accent="#266cac" />
    </motion.div>
  );
}
